(function ($) {
    let delay = 3000;
    let searchClass = ".ProductItem__ImageWrapper--withAlternateImage";
    let toggleClass = "hover";
  
    function toggleRandomCell() {
        let cells = Array.from($(searchClass));
        let cell = returnRandomCell(cells);
        toggleHover(cell);
    }
  
    function returnRandomCell(array) {

        let index = Math.floor(Math.random() * array.length);
        return array[index];
    }
  
    function toggleHover(cell) {

        if (cell) {
            cell.classList.toggle(toggleClass);

        }
    }

    setInterval(toggleRandomCell, delay);
}(jQuery));